import { List, Record } from 'immutable'

export const TeamAvailabilitySettings = Record({
  id: null,
  updatedAt: Date.now() * 1000,
  openHours: List(),
  name: undefined,
  timezone: 'America/New_York',
})

export const AvailabilitySlotTime = Record({
  hour: 0,
  minutes: 0,
})

export const AvailabilitySlot = Record({
  dayOfWeek: undefined,
  startTime: AvailabilitySlotTime(),
  endTime: AvailabilitySlotTime(),
})

export const DEFAULT_AVAILABILITY_SLOT = AvailabilitySlot({
  dayOfWeek: 'WEEKDAYS',
  startTime: AvailabilitySlotTime({
    hour: 9,
    minutes: 0,
  }),
  endTime: AvailabilitySlotTime({
    hour: 17,
    minutes: 0,
  }),
})



// WEBPACK FOOTER //
// ./src/scripts/app/modules/teams/models.js